import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-loading-spinner',
    templateUrl: './loading-spinner.component.html',
    styleUrl: './loading-spinner.component.scss',
    standalone: false
})
export class LoadingSpinnerComponent {
	@Input() spinner: number = 5;
	@Input() size: number = 2;
	
	get spinners(): number[] {
    return Array.from({length: this.spinner}, (_, i) => i);
  }

}
